import React from 'react'
import { Link } from '@inertiajs/react'

/**
 * A styled back link for form pages
 *
 * @example
 * <BackLink href="/manage/facilities">Back to Facilities</BackLink>
 */
export default function BackLink({ href, children }) {
  return (
    <div className="mb-6">
      <Link
        href={href}
        className="text-sm text-sky-600 hover:text-sky-500"
      >
        &larr; {children}
      </Link>
    </div>
  )
}
